module.exports = __webpack_public_path__ + "static/media/kwt_product_logo.8049f8ee.png";